<script>

    import { toast } from 'bulma-toast'
    import { tipStore, tipsStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import TipsService from '../$services/tips.service'

    import ButtonDelete from '../$components/button.delete.svelte'
    import DateMethods from '../$methods/date.methods'
    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'

    let loading = false

    async function deleteTip() {
    
        loading = true
        const resp = await TipsService.deleteTip($tipStore._id)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tipsStore.remove($tipStore._id)
        modalStore.close()

        toast({message: 'Tip borrado', type: 'is-success'})
    }

</script>

<div class="columns">
    <div class="column">
        <Value label="Tipo" value={ $tipStore.type } />
    </div>
</div>
<div class="columns">
    <div class="column">
        <Value label="Mensaje" value={ $tipStore.message } />
    </div>
</div>
<div class="columns">
    <div class="column">
        <Value label="Fecha de creación" value={ DateMethods.dateTimeLarge($tipStore.created) } />
    </div>
</div>
<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'SettingsView.Tip.Delete')}
            <ButtonDelete on:confirm={deleteTip} />
        {/if}
        {#if isPermission($adminStore, 'SettingsView.Tip.Update')}
            <Button text="Actualizar" icon="edit" on:click={() => modalStore.open('tip_update_modal')} />
        {/if}
    </div>
</div>